module.exports = require("./lib/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/polyfill.js
 ** module id = 75
 ** module chunks = 0
 **/